export default [
  {
    name: 'terms/detail/privacy',
    path: '/terms/privacy',
    meta: {
      requireSignin: false,
      ui: {
        newHeader: true,
        bottomless: true,
        wide: true,
      },
    },
    component() {
      return import('@/pages/terms/TermsPrivacy.vue')
    },
  },
  {
    name: 'terms/detail',
    path: '/terms/:uuid',
    meta: {
      requireSignin: false,
      ui: {
        newHeader: true,
        bottomless: true,
        wide: true,
      },
    },
    component() {
      return import('@/pages/terms/TermsDetail.vue')
    },
  },
]
